import DataValidation from './data-validation-page'

export default DataValidation